import { TextClearFormat16, TextFill16 } from '@carbon/icons-react';
import { Divider, Dropdown } from 'antd';
import React, { FC } from 'react';
import { GithubPicker } from 'react-color';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ozoneColorsArr40 } from 'config/ozone-colors';
import { useDocuments } from '../../document-store';
import { ToolButtonWrapper } from '../tool-button-wrapper';

const StyledWrapper = styled.div`
  box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 12px;
  border-radius: var(--spacing-02);

  & .github-picker {
    box-shadow: none !important;
  }
`;

const NoneOption = styled.div`
  display: flex;

  cursor: pointer;
  padding: var(--spacing-03);
  align-items: center;
  gap: 2px;
  background-color: var(--white-100);
`;

const StyledDivider = styled(Divider)`
  margin: 0;
`;

const StyledClearIcon = styled(TextClearFormat16)`
  margin-right: var(--spacing-03);
`;

export const HighlightText: FC<{ editor?: any }> = ({ editor: _editor }) => {
  const [state] = useDocuments();
  const editor = _editor ?? state.editor;

  const executes = (color: string) => {
    editor?.execute('fontBackgroundColor', {
      value: color,
    });
    editor?.editing.view.focus();
  };

  const onChangeComplete = (newColor) => {
    const color = newColor.hex;

    executes(color);
  };

  const PickerMenu = () => (
    <StyledWrapper className="rl-text-color-picker-wrapper">
      <GithubPicker
        triangle="hide"
        onChangeComplete={onChangeComplete}
        colors={ozoneColorsArr40}
      />
      <StyledDivider />
      <NoneOption onClick={() => executes('')}>
        <StyledClearIcon />
        <FormattedMessage id="none" />
      </NoneOption>
    </StyledWrapper>
  );

  return (
    <Dropdown overlay={PickerMenu} trigger={['hover']} placement="bottomRight">
      <div>
        <ToolButtonWrapper>
          <TextFill16 />
        </ToolButtonWrapper>
      </div>
    </Dropdown>
  );
};
